import { ISmartFilterDto } from "../irb-editors.model";

class IAnalysisType {
    constructor(public id: string,
        public name: string,
        public versionId: string) { }
}

class IAnalysisTypeDropDown {
    constructor(public identifier: string,
        public label: string,
        public items: Array<IAnalysisType>) { }
}

interface IAnalysisPackage {
    analysisId: number;
    versionId: number;
    analysisName: string;
    analysisCreatedBy: string;
    tradeExpln: string;
    isDeleted: boolean;
    isSysSuggestion: boolean;
    //Calendar nextRunDate; Calendar lastRunDate; Calendar endDate; String endsOn; 
    analysisType: string;
    environmentId: number;
    portQty: number;
    schedulerFrequency: string;
    status: string;

    isNew: boolean;
    isUIdeleted: boolean;
    userRole: string;
    rowRecordId: number;
    isUIAllPort: boolean;
    isAllPort: boolean;
    totalPfQtyforImaEnv: number;
    isIMAEnv: boolean;

    analysisSchedulerDTO: AnalysisSchedulerDTO; 
    adjustSecDto: IAnalysisAdjustSecuritiesDTO;
    harvestTaxLossDto: any; 
    replaceSecsDto: IAnalysisReplaceSecuritiesDTO; 
    coveredCallDTO: ICoveredCall;
    scheduler: ISchedulerDTO;
    //SmartFilterDTO smartFilterDto; 
    smartFilterDto: ISmartFilterDto;
    modelName?: string;
    modelId?: any
    navigationSource?:any;
    investCashSetting?: string;
}

interface IAnalysisReplaceSecuritiesDTO {
    isTaxable:boolean;
    isQualified:boolean;
    replaceMultipleSecurities:Array<IAnalysisReplaceMultiSecsDTO>;
}

interface IAnalysisReplaceMultiSecsDTO {
    replaceMultipleSecuritiesId:number;
    securityId:number;
    securitySymb:string;
    securityType:string;
    toSellPercent:number;
    shortTermGainPercent:number;
    totalGainPercent:number;
    versionId:number;
    isDeleted:boolean;
    isUIdeleted:boolean;
    isNew:boolean;
    analysisReplaceSecuritiesId:number;
    isSwapExchange:boolean;
    capType:string;
    capPercent:number;
    replacedSymbol:string;
    replacedType:string;
    mutipleSecurityAllocations:Array<IAnalysisReplaceMultiSecsAllocDTO>;
}

interface IAnalysisReplaceMultiSecsAllocDTO {
    multipleSecuritiesId:number;
    securityId:number;
    securitySymb:string;
    securityType:string;
    allocationPercent:number;
    versionId:number;
    isDeleted:boolean ;
    isUIdeleted:boolean;
    isNew:boolean ;
    replaceMultipleSecuritiesId:number;
    isSwapExchange:boolean;
}

interface ISchedulerDTO{
    completedRunTime: string
    createdDate: string
    dateNumber: string
    dayName: string
    endAfterNTimes: string
    endByDate: any
    endDateType: string
    environmentId: number
    everyDay: string
    everyNDays: string
    everyNMonths: string
    everyNWeeks: string
    everyWeekday: string
    friday: boolean
    isActive: boolean
    modifiedBy: string
    modifiedDate: string
    monday: boolean
    monthlyRecurrenceType: string
    nextRunDate: string
    reccuringFreqType: string
    saturday: boolean
    scheduleType: string
    schedulerId: number
    startDate: any
    sunday: boolean
    thursday: boolean
    tuesday: boolean
    version: string
    wednesday: boolean
}
interface IAutoSchedulerDTO{
    autoSchedulerId: number;
    version: number;
    scheduleType: string;
    isActive: boolean;
    startDate: any;
    endDateType: string;
    endByDate: any;
    endAfterNTimes: number;
    nextRunDate: any;
    completedRunTime: number;
    modifiedBy: string;
    modifiedDate: any;
    createdBy: string;
    createdDate: any;
    portfolioId: number;
    environmentId: number;
    recurringFreqType: string;
    everyNDays: number;
    everyDay: string;
    everyWeekday: string;
    everyNMonths: number;
    dateNumber: number;
    monthlyRecurrenceType: string;
    dayName: string;
    everyNWeeks: number;
    monday: boolean;
    tuesday: boolean;
    wednesday: boolean;
    thursday: boolean;
    friday: boolean;
    saturday: boolean;
    sunday: boolean;
    isDeleted: boolean;
}

interface ICoveredCall {
    action: string;
    buyUsingCashTarget: boolean;
    buyUsingCashMinimum: boolean;
    isTaxable: boolean;
    isQualified: boolean;
    allocations: Array<ICoveredCallAllocation>;
}
interface AnalysisSchedulerDTO{

}

interface IAnalysisAdjustSecuritiesDTO{
    isTaxable: boolean;
    isQualified: boolean;
    isCashMin: boolean;
    isCashMax: boolean;
    isCashTarget: boolean;
    includeEquivalentAndAltSecurities: boolean;
    adjustMultipleSecurities: Array<IAnalysisAdjustMultiSecsDTO>
}

interface IAnalysisAdjustMultiSecsDTO{
    adjustMultSecId: number;
    securityId: number;
    securitySymb: string;
    targetType: string;
    targetPercent: number;
    transactionType: string;
    versionId: number;
    isDeleted: boolean;
    isUIdeleted: boolean;
    isNew: boolean;
}

interface ICoveredCallAllocation {
    allocationId: number;
    underlyingId?: number;
    underlyingSymbol: string;
    isDeleted?: boolean;
    isUIdeleted: boolean;
    isNew?: boolean;
    optionSymbol: string;
    optionSymbolToRollTo: string;
    positionType: string;
    optionSecId: number;
    percentOfUnderlyingToCover: number;
    percentOfUnderlyingToPurchase: number;
    percentOfUnderlyingToTrim: number;
    percentOfOptionToBuyBack: number;
    percentOfCoverCallToRoll: number;
    underlyingTarget: string;
    optionSelectionMode: string;
    daysToExpiration: number;
    optionDaysToExpiration?: number;
}

interface IUIDropDown {
    name: string;
    id: string;
    versionId: number;
}

interface ICoveredCallTradeTypes {
    label: string;
    identifier: string;
    items: Array<IUIDropDown>;
}

interface ISecurityDropDownItem {
    isFollowingCatSuggestion: boolean;
    restriction: any;
    securityDescription: string;
    securityExists: boolean;
    securityId: number;
    securitySymbol: string;
    securityType: string;
    versionId: any;
}

interface ISecurityDropDown {
    label: string;
    identifier: string;
    items: Array<ISecurityDropDownItem>;
}

interface ISaveRebalanceResponse {
    responseData: any;
    responseStatus: string;
    responseUtilityMap: any;
}

interface ISaveRebalanceStatus {
    status: string;
    rebalanceResultId: number;
    rebalanceName: string;
    analysisId: number;
    submittedCount: number;
    completedCount: number;
    failedCount: number;
    failMsg: string;
}

interface ISaveRebalanceAsync {
    rprasId: string
}

interface IAnalysisAccountDTO {
    accountId: number;
    accountNumber: string;
    accountName: string;
    accountType: string;
    isSMA: boolean;
    isLiquidate: boolean;
    isFrozen: boolean;
    extraCashAmount: number;
    isImported: boolean;
    accountMarketValue: number;
    isUserAuthorized: boolean;
}

interface IAnalysisPortfolioDTO {
    portfolioId: number;
    portfolioName: string;
    status: string;
    isUIdeleted: boolean;
    isNew: boolean;
    isImported: boolean;
    isSmartFiltered: boolean;
    analysisAccountDtoList: Array<IAnalysisAccountDTO>;
    aggAmount: number;
    htlAmount: number;
    lossPrty: string;
    acctQty: number;
    pfExtraCash: number;
}

enum InvestCashSetting {
    NotApplicable = 'NotApplicable',
    Securities = 'Securities',
    ModelSecurities = 'ModelSecurities'
}

export {
    IAnalysisType,
    IAnalysisTypeDropDown,
    IAnalysisPackage,
    ICoveredCall,
    AnalysisSchedulerDTO,
    ICoveredCallAllocation,
    IUIDropDown,
    ICoveredCallTradeTypes,
    ISecurityDropDownItem,
    ISecurityDropDown,
    ISchedulerDTO,
    ISaveRebalanceResponse,
    ISaveRebalanceStatus,
    ISaveRebalanceAsync,
    IAnalysisReplaceSecuritiesDTO,
    IAnalysisReplaceMultiSecsDTO,
    IAnalysisReplaceMultiSecsAllocDTO,
    IAnalysisAdjustSecuritiesDTO,
    IAnalysisAdjustMultiSecsDTO,
    IAnalysisAccountDTO,
    IAnalysisPortfolioDTO,
    IAutoSchedulerDTO,
    InvestCashSetting
}
